module.exports = __webpack_public_path__ + "static/img/gift-box-reward-gmoney.0ca7417.png";